<template>
  <div class="py-3">
    <div class="border-bottom p-4">
      <CycleTimeline :show-all="true" />
    </div>
    <div v-if="selectedCycle">
      <CycleBlock :cycle="selectedCycle" />
    </div>
    <div v-else>
      <div
        v-for="(cycle, key) in cycles"
        :key="key"
      >
        <CycleBlock :cycle="cycle" />
        <hr v-if="cycle.disabled">
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import CycleTimeline from '@/common/components/CycleTimeline'
import CycleBlock from '@/student/pages/cycle/components/CycleBlock'

export default {
  components: {
    CycleTimeline,
    CycleBlock,
  },
  computed: {
    ...mapGetters([
      'selectedCycle',
      'cycles',
      'trails',
      'selectedTrailId',
      'selectedCycleHasModules'
    ])
  },

}


</script>
